import { getUserStorageLanguage } from '@shared/utils/user';

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState();

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      config.params = {
        ...config.params,
        language: getUserStorageLanguage(),
      };

      return config;
    },
    (err: any) => Promise.reject(err)
  );
}
